// src/config.js
const applicationMode = "development";
var appName = "Student Panel";
var apiUrl = "https://playfull-backend-db.onrender.com/api/";
var pageSize = 10;
var logo = "/logo.png";
var imageBasePath = "https://playfull-backend-db.onrender.com/uploads";

if (applicationMode === 'development') {
  appName = "Student Panel";
  
  //local
  apiUrl = "https://playfull-backend-db.onrender.com/api/"; 
  imageBasePath = "https://playfull-backend-db.onrender.com/uploads";  

  //server
  //apiUrl = "http://13.53.39.107/api/";
  //imageBasePath = "http://13.53.39.107/uploads";
  
}
const config = {
  appName: appName,
  apiUrl: apiUrl,
  pageSize: pageSize,
  logo: logo,
  imageBasePath: imageBasePath,
  razorpayKeyId: "rzp_test_MjZuk8RoXtOCp0",
  razorpayKeySecret: "T5Vn8DtvsjY5kI0uRQCqlYE2",
};
export default config;